// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemEditorHistoryQueryVariables = Types.Exact<{
  itemId?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ItemEditorHistoryQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> }> };


export const ItemEditorHistoryDocument = gql`
    query ItemEditorHistory($itemId: [ID!]) {
  items(filter: {id: $itemId}) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useItemEditorHistoryQuery__
 *
 * To run a query within a React component, call `useItemEditorHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemEditorHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemEditorHistoryQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useItemEditorHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>(ItemEditorHistoryDocument, options);
      }
export function useItemEditorHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>(ItemEditorHistoryDocument, options);
        }
export function useItemEditorHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>(ItemEditorHistoryDocument, options);
        }
export type ItemEditorHistoryQueryHookResult = ReturnType<typeof useItemEditorHistoryQuery>;
export type ItemEditorHistoryLazyQueryHookResult = ReturnType<typeof useItemEditorHistoryLazyQuery>;
export type ItemEditorHistorySuspenseQueryHookResult = ReturnType<typeof useItemEditorHistorySuspenseQuery>;
export type ItemEditorHistoryQueryResult = Apollo.QueryResult<ItemEditorHistoryQuery, ItemEditorHistoryQueryVariables>;